import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { workspacesApi } from "../../api/workspaces.api";

export const useMyWorkspaces = () => {
  return useQuery({
    queryKey: ["workspaces", "mine"],
    queryFn: workspacesApi.getMine,
  });
};

export const useSwitchWorkspace = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (workspaceId: string) => workspacesApi.switchTo(workspaceId),
    // Every workspace-scoped dataset (campaigns, stats, team, integrations…) just changed —
    // refetch everything.
    onSuccess: () => queryClient.invalidateQueries(),
  });
};
